import React, { useState, useEffect, useCallback } from 'react';
import { filterOrdersByDate, updateOrder } from '../services/api';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [size] = useState(8);
  const { id } = useSelector(state => state.auth);
  const navigate = useNavigate();

  const fetchOrders = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await filterOrdersByDate(null, id, null, page, size);
      setOrders(response.data.content);
    } catch (err) {
      console.error('Erreur détaillée:', err);
      setError(err.response?.data?.message || 'Erreur lors du chargement des commandes');
    } finally {
      setLoading(false);
    }
  }, [id, page, size]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const handleUpdateOrderStatus = async (orderId, newStatus) => {
    try {
      setError(null);
      // Find the order to get its current data
      const order = orders.find(o => o.id === orderId);
      if (!order) throw new Error('Commande non trouvée');

   

      // Send the updated order data to the API
      await updateOrder(orderId, newStatus);
      await fetchOrders(); // Refresh data after update
    } catch (err) {
      console.error('Erreur détaillée:', err);
      setError(err.response?.data?.message || 'Erreur lors de la mise à jour du statut');
    }
  };
 
  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'PENDING':
        return 'bg-yellow-100 text-yellow-800';
      case 'PREPARING':
        return 'bg-green-100 text-green-800';
      case 'READY':
        return 'bg-red-100 text-red-800';
          case 'SERVED':
        return 'bg-green-100 text-green-800';
      case 'CANCELED':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-800 mx-auto"></div>
        <p className="mt-4 text-gray-600">Chargement des commandes...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="container mx-auto p-4">
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Erreur!</strong>
        <span className="block sm:inline"> {error}</span>
        <button 
          onClick={fetchOrders}
          className="mt-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
        >
          Réessayer
        </button>
      </div>
    </div>
  );

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Liste des Commandes</h1>
        <div className="flex gap-4">
                  <button
          onClick={() => navigate('/management')}
          className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            
          </svg>
          Retour
        </button>
          <button
            onClick={() => setPage(prev => Math.max(0, prev - 1))}
            disabled={page === 0}
              className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
          >
            Précédent
          </button>
          <button
            onClick={() => setPage(prev => prev + 1)}
            disabled={orders.length < size}
                   className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
          >
            Suivant
          </button>
          <button
            onClick={fetchOrders}
                  className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
          >
            
            Actualiser
          </button>
        </div>
      </div>
      
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Table</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {orders.map((order) => (
              <tr key={order.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{order.id}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {new Date(order.createdAt).toLocaleString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{order.table?.id ?? 'null'}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <select
                    value={order.status}
                    onChange={(e) => handleUpdateOrderStatus(order.id, e.target.value)}
                    className={`block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-amber-500 focus:border-amber-500 sm:text-sm rounded-md ${getStatusBadgeColor(order.status)}`}
                  >
                   <option value="PENDING">En attente</option>
<option value="PREPARING">En préparation</option>
<option value="READY">Prête</option>
<option value="SERVED">Terminée</option>
<option value="CANCELED">Annulée</option>

                  </select>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <button
                    onClick={() => navigate(`/orders/${order.id}`)}
                          className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
                  >
                    Voir détails
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderList;